import { RouterActions, ROUTE_URL, CHANGE_LOCALE } from './router.actions.type';
import { RouterState } from './router.type';
import { Dispatch } from 'redux';
import { RootState } from '../root-reducer';
import { setCurrentLocale } from '../../services/utils.service';

const routerState = (routerState: RouterState): RouterActions => {
  return {
    type: ROUTE_URL,
    payload: routerState,
  };
};

export const setNewLocale = (locale: string) => {
  return async (
    dispatch: Dispatch<RouterActions>,
    getState: () => RootState
  ) => {
    setCurrentLocale(locale);
    dispatch({
      type: CHANGE_LOCALE,
      locale,
    });
  };
};

export const routeTo = (route: string) => {
  return async (
    dispatch: Dispatch<RouterActions>,
    getState: () => RootState
  ) => {
    let state;
    switch (route) {
      case '/login':
        state = {
          title: 'login',
          showHeader: false,
        };
        break;
      default:
        state = {
          title: 'Starter',
          showHeader: true,
        };
        break;
    }
    dispatch(routerState(state));
  };
};
